import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ShareRoutingModule } from './share-routing.module';
import { ShareHistoryComponent } from './share-history/share-history.component';
import { ShareComponent } from './share.component';
import { SharedModule } from '@shared';
import { ShareCertificateComponent } from './share-certificate/share-certificate.component';


@NgModule({
  declarations: [
    ShareComponent,
    ShareHistoryComponent,
    ShareCertificateComponent,
  ],
  imports: [
    CommonModule,
    ShareRoutingModule,
    SharedModule,
  ],
})
export class ShareModule { }
